const trig = document.querySelector(".menu-link");
if (trig) {
   trig.addEventListener("click", (e) => {
      var line1, line2, line3;
      line1 = document.getElementById("hamburger-line-1").classList.toggle("active");
      line2 = document.getElementById("hamburger-line-2").classList.toggle("active");
      line3 = document.getElementById("hamburger-line-3").classList.toggle("d-none");
   });
}
